package co.maytes.standupbot.dashboard.stores

import com.kttipay.mvi.api.MVIAction
import com.kttipay.mvi.api.MVIIntent
import com.kttipay.mvi.api.MVIState

enum class ToastKind { Success, Error, Info }

data class Toast(val id: Long, val message: String, val kind: ToastKind)

object UiContract {
    data class State(val toast: Toast? = null) : MVIState

    sealed interface Intent : MVIIntent {
        data class ShowToast(val toast: Toast) : Intent
        data object DismissToast : Intent
    }

    sealed interface Action : MVIAction
}
